import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useLanguageSpecificationApi } from "../../../../common/api/orders-api/language-specification/useLanguageSpecificationApi";
import {
    createLanguageSpecificationDashboardItem,
    defaultLanguageSpecificationDashboardItem,
    LanguageSpecificationDashboardItem
} from "../LanguageSpecificationDashboardItem";
import { LanguageSpecificationDashboardContext } from "./LanguageSpecificationDashboardContext";

export const LanguageSpecificationDashboardProvider: React.FC = ({ children }) => {
    const { getLanguageSpecificationById } = useLanguageSpecificationApi();

    const { languageSpecificationId } = useParams<{ languageSpecificationId: string }>();

    const [languageSpecificationDashboardItem, setLanguageSpecificationDashboardItem] = useState<
        LanguageSpecificationDashboardItem
    >(defaultLanguageSpecificationDashboardItem);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setIsLoading(true);

        getLanguageSpecificationById(languageSpecificationId)
            .then((response) => {
                const dashboardItem = createLanguageSpecificationDashboardItem(response);
                setLanguageSpecificationDashboardItem(dashboardItem);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const updateMappingItem = (request: MappingUpdateRequest) => {
        setLanguageSpecificationDashboardItem((prevState) => {
            return {
                ...prevState,
                mappings: prevState.mappings.map((mapping) =>
                    mapping.languageId === request.languageId
                        ? {
                              ...mapping,
                              soundtrackCode: request.soundtrackCode,
                              subtitleCode: request.subtitleCode,
                              isModified: true
                          }
                        : mapping
                )
            };
        });
    };

    return (
        <LanguageSpecificationDashboardContext.Provider
            value={{
                isLoading: isLoading,
                languageSpecificationDashboardItem,
                updateMappingItem
            }}
        >
            {children}
        </LanguageSpecificationDashboardContext.Provider>
    );
};

export interface MappingUpdateRequest {
    languageId: string;
    soundtrackCode?: string;
    subtitleCode?: string;
}
